
import { onMounted,ref,reactive } from "vue";
import ActionBar from "../components/ActionBar/index.vue";
import {
  nativeGoBack,
  nativeShowAioShare,
} from "../utils/nativeFn";
export default {
  props: {
    showActionBar: {
      type: Boolean,
      default: false,
    }
  },
  components: {
    ActionBar,
  },
  setup(props, ctx) {
    const clickRefresh = () => {
      ctx.emit("clickRefresh");
    };
    let statusBarHeight = ref(35); // 状态栏高度
    let actionBarHeight = ref(79); // 默认actionBar高度
    const actionBarInfo = reactive({}); // actionBar需要的参数
    const needShare = false;
        // 左侧返回
    const goBack = () => {
      console.log("调用端返回");
      nativeGoBack({}, (res) => {
        console.log("h5调用端上nativeGoBack", res); // app返回给前端的值
      });
    };
    onMounted(() => {
      console.log(props.showActionBar,'props.showActionBar')
      if(props.showActionBar){
        Object.assign(actionBarInfo, {
          actionBarTitle: " ",
          actionBarBg: "#ffffff",
        });
      }
    });
    return {
      clickRefresh,
      needShare,
      actionBarInfo,
      goBack
    };
  },
};
